export const state = () => ({
	current_step: 1,
});
export const mutations = {
	setCurrentStep(state: any, payload: any) {
		state.current_step = payload;
	},
};
export const getters = {
	getCurrentStep: (state: any) => state.current_step,
};
export const actions = {
	async registerUser(state: any, payload: any) {
		await this.$axios.get('sanctum/csrf-cookie');
		return new Promise((resolve, reject) => {
			this.$axios
				.post('/register', payload)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async registerCompany(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.post('/api/company', payload)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async uploadCompanyLogo(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.post('/api/company/' + state.rootState.auth.user.company.uuid + '/logo', payload)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async updateBilling(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.put('/api/company/' + state.rootState.auth.user.company.uuid + '/billing', payload)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async createCompanyAddress(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.post('/api/company/' + state.rootState.auth.user.company.uuid + '/address', payload)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async getCompanyDetails(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.get('/api/company/' + payload)
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async updateCompanyDetails(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.put('/api/company/' + state.rootState.auth.user.company.uuid, {
					web_address: payload,
				})
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async updateSocials(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.put('/api/company/' + state.rootState.auth.user.company.uuid + '/socials', payload)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	setCurrentStep(state: any, payload: any) {
		state.commit('setCurrentStep', payload);
	},
};
